/* eslint-disable sort-keys */
export const DEFAULT_BASIC_IFRAME_MODAL_LAUNCHER_URL_ENTRIES = [
  [
    'DASHBOARD_GETTING_STARTED_ADMIN', {
      _id: 'DASHBOARD_GETTING_STARTED_ADMIN',
      bannerConfig: {
        _id: 'DASHBOARD_GETTING_STARTED_ADMIN',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_STUDENT', {
      _id: 'DASHBOARD_GETTING_STARTED_STUDENT',
      bannerConfig: {
        _id: 'DASHBOARD_GETTING_STARTED_STUDENT',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_TEACHER', {
      _id: 'DASHBOARD_GETTING_STARTED_TEACHER',
      bannerConfig: {
        _id: 'DASHBOARD_GETTING_STARTED_TEACHER',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_ADMIN', {
      _id: 'FLOATING_HELP_ADMIN',
      bannerConfig: {
        _id: 'FLOATING_HELP_ADMIN',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_STUDENT', {
      _id: 'FLOATING_HELP_STUDENT',
      bannerConfig: {
        _id: 'FLOATING_HELP_STUDENT',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_TEACHER', {
      _id: 'FLOATING_HELP_TEACHER',
      bannerConfig: {
        _id: 'FLOATING_HELP_TEACHER',
        actionConfig: {
          buttonLabelKey: '',
          headerTitleKey: '',
          iframeModalLauncherObj: null
        },
        actionType: 'IFRAME_MODAL_LAUNCHER',
        bannerMsgType: 'MESSAGE_WITH_ACTION',
        translationKey: '',
        pathnames: []
      },
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ]
];
